import React from 'react';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';

import { USER_NAME } from '../config';
import { FormattedMessage, injectIntl } from '../../../util/reactIntl';
import { Button, FieldTextInput } from '../../../components';
import { required, composeValidators } from '../../../util/validators';

import css from '../EditUserInfoModal.css';
import { ProtectionInfoIcon } from '../../../icons';
import classNames from 'classnames';
import { checkIfUserIsAnonymous } from '../../../util/anonym';

const EditUserNameForm = ({
    intl,
    values,
    onSubmit,
    pristine,
    currentUser,
    initialValues,
    updateInProgress,
}) => {
    const { firstName, lastName } = values || {};
    const { firstName: initialFirstName, lastName: initialLastName } = initialValues;
    const disabled = !firstName || !lastName || pristine;
    const displayName = `${firstName} ${(lastName || '').charAt(0).toLocaleUpperCase()}`.trim();

    const handleSubmit = () => {
        const isAnonymousUser = checkIfUserIsAnonymous(currentUser);

        if (isAnonymousUser) {
            onSubmit(
                {
                    anonymousListingTitle: `${firstName} ${lastName}`,
                },
                null,
                {}
            );
        } else {
            onSubmit({}, null, { firstName, lastName, displayName });
        }
    };

    return (
        <>
            <section className={css.holderSpacing}>
                <FieldTextInput
                    id="firstName"
                    name="firstName"
                    type="text"
                    placeholder="Vorname"
                    validate={composeValidators(
                        required(
                            intl.formatMessage({
                                id: 'EditListingDescriptionForm.descriptionRequired',
                            })
                        )
                    )}
                />
                <FieldTextInput
                    id="lastName"
                    name="lastName"
                    type="text"
                    placeholder="Nachname"
                    validate={composeValidators(
                        required(
                            intl.formatMessage({
                                id: 'EditListingDescriptionForm.descriptionRequired',
                            })
                        )
                    )}
                />
            </section>

            <footer>
                <div className={classNames([css.userDataProtectedMessage, css.mt4, css.mb24])}>
                    <ProtectionInfoIcon />
                    <FormattedMessage id="ProfileSettingsForm.nameNotPubliclyVisibleNotification" />
                </div>

                <Button disabled={disabled} onClick={handleSubmit} inProgress={updateInProgress}>
                    <FormattedMessage
                        id={`ProfileSettingsForm.editUserInfoAction-${
                            initialFirstName && initialLastName ? 'edit' : USER_NAME
                        }`}
                    />
                </Button>
            </footer>
        </>
    );
};

const EditUserNameSection = ({ ...restProps }) => (
    <FinalForm
        {...restProps}
        render={fieldRenderProps => (
            <EditUserNameForm {...fieldRenderProps} onSubmit={restProps.onSubmit} />
        )}
    />
);

export default compose(injectIntl)(EditUserNameSection);
